import { menuClasses } from 'react-pro-sidebar';
import { hexToRgba } from '../utils/utils';

export const themes = {
  light: {
    sidebar: {
      backgroundColor: '#FFFFFF',
      color: '#010101',
    },
    menu: {
      menuContent: '#fbfcfd',
      icon: '#010101 ',
      hover: {
        backgroundColor: '#FFF3EB',
        color: '#FD6900',
      },
      disabled: {
        color: '#9fb6cf',
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor: '#0b2948',
      color: '#8ba1b7',
    },
    menu: {
      menuContent: '#082440',
      icon: '#59d0ff',
      hover: {
        backgroundColor: '#00458b',
        color: '#b6c8d9',
      },
      disabled: {
        color: '#3e5e7e',
      },
    },
  },
};

export const menuItemStyles = (theme) => {
  return {
    root: {
      fontSize: '18px',
      fontWeight: 400,
    },
    icon: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      [`&.${menuClasses.active}`]: {
        color: themes[theme].menu.hover.color,
      },
    },
    button: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      '&:hover': {
        backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, 1),
        color: themes[theme].menu.hover.color,
      },
      [`&.${menuClasses.active}`]: {
        backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, 1),
        color: themes[theme].menu.hover.color,
      },
    },
  };
};
